import { render, staticRenderFns } from "./foodPackList.vue?vue&type=template&id=dac55bd4&scoped=true&"
import script from "./foodPackList.vue?vue&type=script&lang=js&"
export * from "./foodPackList.vue?vue&type=script&lang=js&"
import style0 from "./foodPackList.vue?vue&type=style&index=0&id=dac55bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac55bd4",
  null
  
)

export default component.exports